import React, { useEffect, useRef, useState } from "react";
import "./AssignPhotographerModal.css";
import { toast } from "react-toastify";
import Loader from "../../../../Loader/Loader";
import { AssignPhotographerToBookingAPI } from "../../../../utils/APIs/bookingsApis";
import { getVerifiedPhotographersAPI } from "../../../../utils/APIs/photographersApis";
import { useNavigate } from "react-router-dom";

const AssignPhotographerModal = ({ booking, isOpen, onClose, refetchData }) => {
    const [photographers, setPhotographers] = useState([]);
    const [photographerSearch, setPhotographerSearch] = useState("");
    const [isPhotographerDropdownOpen, setIsPhotographerDropdownOpen] = useState(false);
    const [loadingPhotographers, setLoadingPhotographers] = useState(false);
    const photographerDropdownRef = useRef(null);
    const LIMIT = 10;

    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / LIMIT);
    // const [requirements, setRequirements] = useState([]);

    console.log("BOOKING", booking)
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        photographerId: "",   // ✅ add this
    });
    const [loadingAddBooking, setLoadingAddBooking] = useState(false);
    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    useEffect(() => {
        const handleClickOutside = (event) => {

            if (
                photographerDropdownRef.current &&
                !photographerDropdownRef.current.contains(event.target)
            ) {
                setIsPhotographerDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    useEffect(() => {
        if (!isOpen) return;

        fetchPhotographers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, page]);

    const fetchPhotographers = async (pageNo = page) => {
        try {
            setLoadingPhotographers(true);

            const res = await getVerifiedPhotographersAPI(pageNo, LIMIT);

            setPhotographers(res?.data?.photographers || []);
            setTotal(res?.data?.meta?.total || 0);
            setPage(res?.data?.meta?.page || pageNo);

        } catch (error) {
            console.error("Photographer fetch failed", error);
        } finally {
            setLoadingPhotographers(false);
        }
    };


    if (!isOpen) return null;


    const filteredPhotographers = photographers.filter((p) =>
        p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
        p.mobileNumber?.includes(photographerSearch)
    );

    const resetForm = () => {
        setFormData({
            eventType: "",
            startDate: "",
            endDate: "",
            location: "",
            currentBudget: "",
            flatOrHouseNo: "",
            streetName: "",
            city: "",
            postalCode: "",
            state: "",
            userId: "",
        });

        // setRequirements([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("HELLOOO")

        if (!formData.photographerId) {
            toast.error("Please select a photographer");
            return;
        }

        try {

            setLoadingAddBooking(true)


            const payload = {
                bookingId: booking.bookingId,
                photographerId: formData.photographerId,
            };
            const response = await AssignPhotographerToBookingAPI(payload);

            if (response?.data?.success) {
                toast.success(response?.data?.message || "The Booking is assign to photographer successfully!");
                // fetchBookings()
                refetchData()
                resetForm();
                onClose();
            } else {
                toast.error(response?.data?.message || "Failed to assign booking!");
            }
        } catch (error) {
            setLoadingAddBooking(false)
            console.error("Create Booking Error:", error);
            toast.error("Something went wrong");
        }
        finally {
            setLoadingAddBooking(false)
        }
    };

    if (loadingAddBooking) {
        return <Loader />
    }
    return (
        <div className="assign-photographer-modal-overlay">
            <div className="assign-photographer-modal-container">

                <div className="assign-photographer-modal-header">
                    <h3>Assign Photographer</h3>

                    <div className="booking-info-grid">
                        <div className="booking-info-item">
                            <span>Booking ID</span>
                            <p>{booking?.veroaBookingId || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Amount</span>
                            <p>₹ {booking?.bookingAmount || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Event Type</span>
                            <p>{booking?.eventType || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Location</span>
                            <p>{booking?.location || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Start Date</span>
                            <p>
                                {formatDate(booking.startDate) || "-"}
                            </p>
                        </div>

                        <div className="booking-info-item">
                            <span>End Date</span>
                            <p>
                                {formatDate(booking.endDate) || "-"}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="assign-photographer-modal-body">
                    <form id="bookingForm" onSubmit={handleSubmit} className="assign-photographer-form">



                        {/* Photographer Dropdown (like customer) */}
                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Assign Photographer *</label>

                            <div className="user-dropdown" ref={photographerDropdownRef}>
                                <div className="dropdown-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search Photographer by name or mobile..."
                                        value={photographerSearch}
                                        onChange={(e) => {
                                            setPhotographerSearch(e.target.value);
                                            setIsPhotographerDropdownOpen(true);
                                        }}
                                        onFocus={() => setIsPhotographerDropdownOpen(true)}
                                    />
                                    <span className="dropdown-arrow">▼</span>
                                </div>

                                {isPhotographerDropdownOpen && (
                                    <div className="assign-photographer-dropdown-list">
                                        {loadingPhotographers ? (
                                            <div className="dropdown-status">Loading photographers...</div>
                                        ) : filteredPhotographers.length === 0 ? (
                                            <div className="dropdown-empty">
                                                <p>No photographer found</p>
                                                <button
                                                    type="button"
                                                    className="btn-primary"
                                                    onClick={() => {
                                                        setIsPhotographerDropdownOpen(false);
                                                        navigate("/photographer")
                                                    }}
                                                >
                                                    + Add New Photographer
                                                </button>
                                            </div>
                                        ) : (
                                            filteredPhotographers.map((photographer) => (
                                                <div
                                                    key={photographer._id}
                                                    className={`assign-photographer-dropdown-item ${formData.photographerId === photographer._id ? "selected" : ""
                                                        }`}
                                                    onClick={() => {
                                                        setFormData({
                                                            ...formData,
                                                            photographerId: photographer._id,
                                                        });

                                                        setPhotographerSearch(
                                                            photographer.name || photographer.phone || photographer?.email);

                                                        setIsPhotographerDropdownOpen(false);
                                                    }}
                                                >

                                                    <div className="user-name">{photographer.name}</div>
                                                    <div className="user-mobile">
                                                        {photographer.phone}
                                                    </div>
                                                    {photographer.email && (
                                                        <div className="user-email">{photographer.email}</div>
                                                    )}
                                                    <hr className="assign-photographer-text" />
                                                </div>

                                            ))
                                        )}
                                    </div>
                                )}
                                {totalPages > 1 && filteredPhotographers.length > 0 && (
                                    <div className="pagination">
                                        <button
                                            type="button"
                                            className="pagination-btn"
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            Prev
                                        </button>

                                        {[...Array(totalPages)].map((_, i) => (
                                            <button
                                                key={i}
                                                className={`pagination-btn ${page === i + 1 ? "active" : ""}`}
                                                onClick={() => setPage(i + 1)}
                                                type="button"
                                            >
                                                {i + 1}
                                            </button>
                                        ))}

                                        <button
                                            type="button"
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                            className="pagination-btn"
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>

                        </div>





                    </form>

                </div>

                <div className="quote-modal-footer">
                    <button className="btn-secondary" type="button"
                        onClick={() => {
                            resetForm();
                            onClose();
                        }}>
                        Cancel
                    </button>
                    <button className="btn-primary" type="submit" form="bookingForm">
                        Assign Photpgrapher
                    </button>
                </div>

            </div>
        </div>
    );
};

export default AssignPhotographerModal;